var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_545_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.07143 5.50005V3.01645C4.07143 2.44497 4.42344 1.92935 4.95357 1.72739L9.025 0.180518C9.33036 0.064502 9.66964 0.064502 9.97924 0.180518L14.0507 1.72739C14.5808 1.92935 14.9328 2.44067 14.9328 3.01645V5.50005H14.9201C14.9286 5.61177 14.9328 5.72778 14.9328 5.8438V7.56255C14.9328 10.6004 12.5027 13.0625 9.50424 13.0625C6.5058 13.0625 4.07567 10.6004 4.07567 7.56255V5.8438C4.07567 5.72778 4.07991 5.61177 4.08839 5.50005H4.07143ZM6.10714 7.56255C6.10714 9.46177 7.62545 11 9.5 11C11.3746 11 12.8929 9.46177 12.8929 7.56255V6.87505H6.10714V7.56255ZM4.74576 14.0809C5.19107 13.9348 5.67031 14.0981 5.99263 14.4461L9.00379 17.6903C9.27098 17.9782 9.72478 17.9782 9.99196 17.6903L13.0031 14.4461C13.3254 14.0981 13.8047 13.9348 14.25 14.0809C17.0067 14.979 19 17.5915 19 20.6809C19 21.4114 18.4147 22 17.698 22H1.30201C0.585268 22 0 21.4071 0 20.6809C0 17.5915 1.9933 14.979 4.74576 14.0809ZM8.82143 2.06255V2.75005H8.14286C7.95625 2.75005 7.80357 2.90474 7.80357 3.0938V3.7813C7.80357 3.97036 7.95625 4.12505 8.14286 4.12505H8.82143V4.81255C8.82143 5.00161 8.97411 5.1563 9.16071 5.1563H9.83928C10.0259 5.1563 10.1786 5.00161 10.1786 4.81255V4.12505H10.8571C11.0437 4.12505 11.1964 3.97036 11.1964 3.7813V3.0938C11.1964 2.90474 11.0437 2.75005 10.8571 2.75005H10.1786V2.06255C10.1786 1.87349 10.0259 1.7188 9.83928 1.7188H9.16071C8.97411 1.7188 8.82143 1.87349 8.82143 2.06255Z",
    fill: "#1E3050"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_545_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 22,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user.00c54bb5.svg";
export { ForwardRef as ReactComponent };